import { Box, InputBase } from "@mui/material";
import Shbutton from "../buttons/Shbutton";

import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import { useTheme } from "@emotion/react";
import { tokens } from "../../../theme";
import { useState, useEffect, useRef } from "react";
import { showToastMessage } from "../../../utils/toasts";
import { useTranslation } from "react-i18next";

const NumberInput = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();

    const [value,setValue] = useState(props.value ?? null);
    const internalChange = useRef(false);
    const changeBy = props.changeBy ?? 1;
    const btnSize = props.btnSize ?? 32;
    const maxWidth = props.maxWidth ?? 1;

    useEffect(() => {
        if (internalChange.current) {
            internalChange.current = false;
            return;
        }
        setValue(props.value);
    },[props.value]);

    // const handleChange = (input) => {
    //     console.log("input",input);
    //     const validPattern = /^\d*\.?\d*$/;
    
    //     if (props.onlyPositive) {
    //         if (!validPattern.test(input) || input === '' || parseFloat(input) <= 0) {
    //             showToastMessage("warning", t("quantity_must_be_greater_than_0"));
    //             return;
    //         }
    //     }
    
    //     setValue(input);
    
    //     const parsedNum = parseFloat(input);
    //     if (!isNaN(parsedNum) && typeof props.change !== "undefined") {
    //         props.change(parsedNum);
    //     }
    // };
    
    const handleChange = (input) => {
        let strInput = typeof input === 'number' ? String(input) : input;
        
        const validPattern = props.onlyPositive
        ? /^\d*\.?\d*$/
        : /^-?\d*\.?\d*$/;
    
        if (strInput === '') {
            internalChange.current = true;
            setValue('');
            if (typeof props.change === "function") {
                props.change('');
            }
            return;
        }
    
        if (!validPattern.test(strInput)) {
            return; 
        }
    
        const parsedNum = parseFloat(strInput);
        if (props.onlyPositive && (isNaN(parsedNum) || parsedNum < 0)) {
            return; 
        }
    
        let finalValue = parsedNum;
    
        // Apply min boundary
        if (typeof props.min !== "undefined" && props.min !== null && parsedNum < props.min) {
            finalValue = props.min;
        }
    
        // Apply max boundary
        if (typeof props.max !== "undefined" && props.max !== null && parsedNum > props.max) {
            finalValue = props.max;
        }
    
        internalChange.current = true;
        setValue(finalValue);

        if (!isNaN(finalValue) && typeof props.change === "function") {
            props.change(finalValue);
        }
    };

    const handleDecrement = () => {
        const current = parseFloat(value) || 0;
        const next = current - changeBy;
    

        if (typeof props.min !== "undefined" && props.min !== null && next < props.min) {
            return;
        }
        handleChange(next);
    };

    const handleIncrement = () => {
        const current = parseFloat(value) || 0;
        const next = current + changeBy;

        // Ensure that the value doesn't exceed props.max (if defined)
        if (typeof props.max !== "undefined" && props.max !== null && next > props.max) {
            return;  // Do nothing if next value exceeds max
        }

        handleChange(next);
    };

    return (
        <Box display="flex"
            borderRadius="20px"
            className="je-moeder"
            backgroundColor={`${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`}
            sx={{
                paddingX:0.5,
                alignItems:"center",
                width:1,
                maxWidth:maxWidth,
                ...props.inputSX
            }}
        >

            {!props.disabled && !props.hideButtons && (
                <Shbutton 
                    className={"s"+btnSize}
                    tabindex={-1}
                    // size={btnSize} 
                    icon 
                    variant="contained" 
                    color="primaryGrey" 
                    type="button"
                    onClick={() => {
                        handleDecrement(1);
                    }}
                    sx={props.btnSx ?? null}
                >
                    <RemoveOutlinedIcon fontSize="small" />
                </Shbutton>
            )}
            <InputBase
                inputRef={props.inputRef ?? null}
                sx={{
                    mx:!props.hideButtons ? 2 : 0, 
                    flex:1,
                    width:1, 
                    color:colors.txt["primary"],
                    height:props.height ?? 40,
                    "& input" : {
                        textAlign:"center"
                    },
                }} 
                inputProps={{
                  min: props.min ?? null, // Set the minimum value
                  readOnly: props.disabled ?? false, // Make readonly when disabled
                }}
                value={value}
                type="number"
                autoFocus={props.autoFocus ?? false}
                // onChange={(e) => setValue(e.target.value)}
                onChange={(e) => {
                    if (!props.disabled) {
                        handleChange(e.target.value)
                    }
                }}
                onBlur={(e) => {
                    if (!props.disabled && typeof props.blur === "function") {
                        props.blur(e.target.value);
                    }
                }}
                />
            {!props.disabled && !props.hideButtons && (
            <Shbutton
                tabindex={-1}
                className={"s"+btnSize}
                // size={btnSize}
                icon 
                variant="contained" 
                color="primaryGrey" 
                type="button"
                // onClick={(e) => setValue((value) => value+changeBy)}
                onClick={() => {
                    handleIncrement(1);
                }}
                sx={props.btnSx ?? null}
            >
                <AddOutlinedIcon fontSize="small" />
            </Shbutton>
            )}
        </Box>
    )
}

export default NumberInput;